import type { PreferencesSet } from '@risksmart-app/shared/knock/schemas';
import type { UpdateNotificationPreferencesMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  GetNotificationPreferencesDocument,
  UpdateNotificationPreferencesDocument,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useUpdateNotificationPreferences = createMutationHook({
  name: 'updateNotificationPreferences',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.notifications.userPreferences.set.mutationOptions({
      onSuccess,
    }),
  mapInput: (input: { preferenceSet: PreferencesSet }) => input,
  invalidate: (trpc) => [
    trpc.frontend.notifications.userPreferences.get.queryKey(),
  ],
  // The set procedure's result carries nothing consumers read — the contract
  // is a static acknowledgement message.
  mapResponse: (): UpdateNotificationPreferencesMutation => ({
    updateNotificationPreferences: {
      __typename: 'UpdateNotificationPreferencesOutput',
      message: 'Preferences updated',
    },
  }),
  graphqlDocument: UpdateNotificationPreferencesDocument,
  graphqlVariables: (input) => ({ ...input }),
  refetchQueries: [GetNotificationPreferencesDocument],
});
